// extracted by mini-css-extract-plugin
module.exports = {"CHECKED":"check_CHECKED__rhGpS","UNCHECKED":"check_UNCHECKED__2YUf7 action"};